import { Component, input, output, ViewChild, AfterViewInit, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeleteComponent } from '../../delete/delete.component';
import { HolidaysService } from '../../../services/holidays/holidays.service';

@Component({
  selector: 'app-rules-list',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatSortModule,
    MatButtonModule,
  ],
  templateUrl: './rules-list.component.html',
  styleUrls: ['./rules-list.component.css', '../../../styles/layout.css'],
})
export class RulesListComponent implements AfterViewInit {
  readonly rules = input<any[]>([]);
  readonly ruleDeleted = output<void>();
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['name', 'rule_type_display', 'value', 'date_range', 'actions'];

  @ViewChild(MatSort) sort!: MatSort;
  readonly dialog = inject(MatDialog);

  constructor(
    private router: Router,
    private holidaysService: HolidaysService
  ) {
    // Use effect to update dataSource when input changes
    effect(() => {
      this.dataSource.data = this.rules();
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  goToRule(ruleId: number, event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevent row click if called from button
    }
    if (!ruleId) return;
    this.router.navigate(['/home/vacations/protocols/rule', ruleId, 'edit']);
  }

  deleteRule(event: Event, ruleId: number, ruleName: string) {
    event.stopPropagation(); // Prevent row click navigation

    const dialogRef = this.dialog.open(DeleteComponent, {
      width: '550px',
      data: {
        title: '¿Seguro que quieres eliminar esta regla?',
        message: ruleName,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        handler: () => this.holidaysService.deleteRule(ruleId),
      },
    });

    const dialogSub = dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        // Emit event to parent component to refresh data
        this.ruleDeleted.emit();
      }
    });
  }
}
